import {Row, Col, Button} from 'react-bootstrap';
import MDMToggle  from './mdmToggle';
import EdgeLockToggle from './edgeLockToggle';
import {useFeatureContext} from '../../lib/context/featureContext';

export const FeatureToggles = (props) => {
  const {feature_mdm, feature_edge_lock, feature_customer_mdm, feature_customer_edge_lock} = useFeatureContext();

  return(
    <Row className="modal-white">
      <Col sm="12" md="6" lg="6">
        <div className="account-form p-3">
          {feature_edge_lock && 
            <Row className="align-items-center feature-row">
              <Col>
                <EdgeLockToggle {...props} />    
              </Col>
            </Row>
          }
          <Row className="feature-row">
            <Col>
              <hr className="feature-hr my-2"/>
            </Col>
          </Row>
          {feature_mdm &&
            <Row className="align-items-center feature-row">
              <Col>
                <MDMToggle {...props} />    
              </Col>
            </Row>
          }
        </div>
      </Col>
    </Row>
  );
}

export default FeatureToggles;
